import React from 'react';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { Box, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import { internImages } from "../../utils/BeadsData";

const InternsProgram = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Container maxWidth="md" sx={{ mt: 12, mb: isMobile ? 2 : 8, px: 2 }}>
                <Typography variant="h3" gutterBottom align="center" fontWeight="bold" my={3}>BEADS Interns Program</Typography>

                <Typography paragraph align="center">
                    Before a BEADS-sponsored girl continues her studies in college, she spends one year as a BEADS Intern. The interns carry out some of BEADS' most important work.
                </Typography>

                <Box textAlign="center" my={3}>
                    <Typography variant="h5" gutterBottom fontWeight="bold">
                        SPONSOR AN INTERN
                    </Typography>

                    <Typography paragraph>
                        For more information or to select a girl to sponsor, contact Debby Rooney at BEADSofKenya@aol.com or visit our contat page for more information.
                    </Typography>
                </Box>

                <Box sx={{ my: 4 }}>
                    <Swiper
                        modules={[Autoplay, Navigation, EffectFade]}
                        effect="fade"
                        // navigation={!isMobile}
                        autoplay={{ delay: 5000, disableOnInteraction: false }}
                        loop={true}
                        style={{ borderRadius: '2rem' }}
                    >
                        {internImages.map((image, index) => (
                            <SwiperSlide key={index}>
                                <Box sx={{ position: 'relative', height: isMobile ? 300 : 470, overflow: 'hidden' }}>
                                    <img src={image.src} alt={image.alt}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                    <Typography
                                        variant={isMobile ? "body2" : "subtitle1"}
                                        sx={{
                                            position: 'absolute',
                                            bottom: 0,
                                            width: '100%',
                                            color: 'white',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            padding: '8px',
                                            textAlign: 'center',
                                            fontSize: isMobile ? '0.75rem' : '1rem',
                                        }}
                                    >
                                        {image.description}
                                    </Typography>
                                </Box>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Box>

                <Typography paragraph textAlign="center" my={3}>
                    Girls who graduate from high school can continue their sponsorship in college if they agree to spend one year as a BEADS intern, teaching and assisting in the remote public schools in their local communities. Our interns are often the only teachers in their classrooms.
                </Typography>
            </Container>
            <FooterOne />
        </Box>
    );
};

export default InternsProgram;
